export const KINDS = {
  DEFAULT: 'Default',
  STATIC: 'Static',
} as const

export const ITEM_KINDS = {
  DEFAULT: 'Default',
  SUCCESS: 'Success',
  FAILURE: 'Failure',
} as const

export enum ToastLifecycle {
  TRANSITION_IN = 'transitionIn',
  TRANSITION_OUT = 'transitionOut',
  TRANSITION_OUT_LEFT = 'transitionOutLeft',
  TRANSITION_OUT_RIGHT = 'transitionOutRight',
  TRANSITION_OUT_UP = 'transitionOutUp',
}

export const DEFAULT_TOAST_TIME = 3000

export const TOAST_DELETE_DELAY = 1000
